export const en = {
  app: {
    sectionWorkspace: "workspace",
    sectionObserve: "observe",
    sectionConfigure: "configure",
    tabChat: "Chat",
    tabPlans: "Plans",
    tabSessions: "Sessions",
    tabOverview: "Overview",
    tabUsage: "Usage",
    tabSystem: "System",
    tabSemantic: "Semantic",
    tabTools: "Tools",
    tabPermissions: "Permissions",
    tabMcp: "MCP",
    tabSkills: "Skills",
    tabMemory: "Memory",
    tabHooks: "Hooks",
    tabSettings: "Settings",
    sectionChanges: "Changes",
    tabChanges: "Changes",
    footer: "127.0.0.1 only · token-gated",
    themeToggle: "Toggle theme",
    themeLight: "Light",
    themeDark: "Dark",
    skill: {
      scope: {
        builtin: "Built-in",
        global: "Global",
        project: "Project",
      },
      runAs: {
        subagent: "Subagent",
        inline: "Inline",
      },
      generic: "Skill",
    },
    exportReasoningSummary: "Reasoning Summary",
    exportToolLabel: "Tool Calls",
    exportUserLabel: "User Messages",
    empty: {
      currentWorkspace: "Current workspace",
      selectWorkspace: "Select a workspace to get started",
      suggestion0: "Start a new conversation",
      suggestion1: "Open settings",
      suggestion2: "View overview",
      suggestion3: "Browse sessions",
      welcome: "Welcome to Reasonix",
    },
    errorLabel: "Error",
    connecting: "Connecting…",
    session: {
      format: "Session",
      new: "New Session",
    },
    setup: {
      choose: "Choose a workspace",
      description: "Select a workspace to start working",
      notSelected: "No workspace selected",
      saveAndStart: "Save & Start",
      welcome: "Welcome",
      workspace: "Workspace",
    },
    tab: {
      newTab: "+ New Tab",
      newTabTitle: "Open a new tab",
    },
    titlebar: {
      clearChat: "Clear Chat",
      close: "Close",
      commandPalette: "Command Palette",
      contextPanel: "Context Panel",
      copyMd: "Copy as Markdown",
      exportMd: "Export as Markdown",
      maximize: "Maximize",
      minimize: "Minimize",
      more: "More",
      restore: "Restore",
      settings: "Settings",
      sidebar: "Sidebar",
      windowControls: "Window Controls",
    },
    toast: {
      cleared: "Chat cleared",
      copied: "Copied to clipboard",
      copiedMd: "Copied as Markdown",
      emptySession: "No messages to export",
      exportDialogTitle: "Export Chat",
      exportedMd: "Exported as Markdown",
      exportFailed: "Export failed",
      langSwitched: "Language switched",
      modelSwitched: "Model → {model}",
      effortSwitched: "Effort → {effort}",
      modeSwitched: "Mode switched",
      newSession: "New session created",
    },
    yolo: {
      toast: "YOLO mode enabled",
    },
    cmd: {
      abort: "Abort",
      btw: "BTW",
      clearChat: "Clear Chat",
      compact: "Compact",
      copyLast: "Copy Last",
      exportMd: "Export as Markdown",
      feedback: "Feedback",
      help: "Help",
      newSession: "New Session",
      retry: "Retry",
      switchModel: "Switch Model",
      toggleCurrency: "Toggle Currency",
      toggleLang: "Toggle Language",
      toggleTheme: "Toggle Theme",
    },
    header: {
      abort: "Abort",
      clickToSelect: "Click to select",
      copy: "Copy",
      copyMd: "Copy as Markdown",
      export: "Export",
      exportMd: "Export as Markdown",
      newChat: "New Chat",
      noWorkspace: "No workspace",
      running: "Running…",
    },
    jumpToBottom: "Jump to bottom",
    langEN: "English",
    langZH: "中文",
    splashSubtitle: "AI-powered coding assistant",
  },
  changes: {
    chatPlaceholder: "Ask about your code...",
    chatWelcome: "Changes — ask questions about your project files.",
    chatSend: "Send",
    viewerPlaceholder: "Select a file to view",
    treeEmpty: "(empty)",
    tabClose: "Close tab",
    newConversation: "New",
    clearConversation: "Clear",
    newTitle: "/new — wipe conversation context",
    clearTitle: "/clear — wipe visible scrollback",
    newConfirmBusy: "A turn is in flight. Abort and start a new conversation?",
    newConfirm: "Clear current conversation and start fresh?",
    newToast: "new conversation",
    clearToast: "scrollback cleared",
    newFailed: "/new failed: {error}",
    clearFailed: "/clear failed: {error}",
    chatSendBtn: "Send",
    fileTreeTitle: "Files",
    codeViewerTitle: "Code Viewer",
    chatPanelTitle: "Chat",
    loadingFiles: "Loading project files…",
    review: "Review",
    allFiles: "All Files",
    changes: "changes",
    commentLabel: "Commenting on line",
    commentPlaceholder: "Add a comment…",
    commentCancel: "Cancel",
    commentSubmit: "Comment",
    commentLine: "Line",
    commentEdit: "Edit",
    commentDelete: "Delete",
    diffSourceGit: "Git changes",
    diffSourceSession: "Previous session",
    diffSourceCheckpoint: "Checkpoint",
    checkpointEmpty: "No checkpoints in this workspace yet.",
    restoreBtn: "Restore",
    restoreConfirm: 'Restore "{name}"? This will overwrite current files.',
    deleteBtn: "Delete",
    deleteConfirm: 'Delete checkpoint "{name}"? Snapshot will be removed, files stay unchanged.',
    createBtn: "Snapshot",
    createPlaceholder: "name for snapshot…",
    backToList: "back to list",
    reviewEmpty: "No pending reviews.",
    diffStyleUnified: "Unified",
    diffStyleSplit: "Split",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    createFailed: "create failed",
    restoreFailed: "restore failed",
    deleteFailed: "delete failed",
  },
  common: {
    loading: "loading…",
    loadingFailed: "{name} failed: {error}",
    back: "← back",
    save: "Save",
    remove: "remove",
    cancel: "Cancel",
    delete: "Delete",
    add: "Add",
    confirm: "Confirm",
    noData: "No {name} yet.",
    all: "all",
    yes: "yes",
    no: "no",
    on: "ON",
    off: "off",
    enabled: "enabled",
    disabled: "disabled",
  },
  settings: {
    title: "Settings",
    loading: "loading settings…",
    saved: "saved: {fields}",
    sectionApi: "DeepSeek API",
    apiKey: "API key",
    apiKeyNotSet: "Not set",
    apiKeySave: "Save key",
    apiKeySet: "Set",
    apiSection: "API Configuration",
    notSet: "(not set)",
    replace: "replace",
    pasteKey: "paste a fresh sk-… token",
    saveKey: "Save key",
    baseUrl: "base url",
    baseUrlPlaceholder: "https://api.deepseek.com (default)",
    baseUrlHint: "Base URL for API requests",
    sectionDefaults: "Defaults",
    effortSection: "Reasoning effort",
    modelCustom: "Custom model id",
    modelCustomHint: "Any OpenAI-compatible id your endpoint serves (vLLM, Ollama, Together, …).",
    modelCustomActive: "Currently running on a custom id: {model}",
    appliesNextTurn: "applies next turn",
    effort: "effort",
    effortMax: "max (DeepSeek extension — rejected by stock OpenAI / vLLM)",
    effortHigh: "high (safe default — vLLM / Azure compatible)",
    effortMedium: "medium",
    effortLow: "low (fastest)",
    webSearch: "web search",
    webSearchNote: "web_fetch + web_search tools",
    webSearchEngine: "search engine",
    webSearchEngineBing: "bing — default, works from CN without proxy",
    webSearchEngineSearxng: "searxng — self-hosted (set endpoint via /se searxng <url>)",
    webSearchEngineMetaso: "metaso — 100/day free (CN-friendly, free key at metaso.cn)",
    webSearchEngineTavily: "tavily — 1000/mo free (set TAVILY_API_KEY)",
    webSearchEnginePerplexity: "perplexity — AI-native (set PERPLEXITY_API_KEY)",
    webSearchEngineExa: "exa — AI-native 1000/mo free (set EXA_API_KEY)",
    webSearchEngineBrave: "brave — independent index, 2000/mo free (set BRAVE_SEARCH_API_KEY)",
    webSearchEngineOllama: "ollama — Ollama cloud web search (set OLLAMA_API_KEY)",
    webSearchEngineNote: "applies to the next web_search call",
    sectionBudget: "Budget",
    budget: "Budget",
    budgetHint: "Set spending limits",
    budgetPlaceholder: "Enter budget amount",
    budgetOf: "of",
    budgetSetCap: "set a cap",
    budgetCustom: "custom",
    budgetBumpHint: "bump the cap to keep going",
    budgetClear: "Clear cap",
    budgetIdleLine: "warns at 80% · refuses past 100%",
    budgetWarnLine: "approaching cap — loop will refuse past 100%",
    budgetRefusing: "cap exhausted — next turn refused until bumped or cleared",
    sectionLoop: "Loop",
    loopIdleHint: "Auto-resubmit a prompt on a fixed interval.",
    loopCostHint: "Each iteration costs ~{cost} (last turn).",
    loopInterval: "interval",
    loopCustom: "custom",
    loopRangeError: "interval must fall in 5s..6h",
    loopPrompt: "prompt",
    loopPromptPlaceholder: "e.g. check the deploy status and report any errors",
    loopStart: "Start loop",
    loopStop: "Stop",
    loopRunning: "running",
    loopIter: "iter {iter}",
    loopFiresIn: "fires in {remaining}",
    sectionSkills: "Skills",
    skillPaths: "skill paths",
    skillPathsPlaceholder: "/path/to/skills-a, /path/to/skills-b",
    skillPathsNote: "comma-separated · next /new or new session",
    skillsEmpty: "No skills loaded",
    skillsLoaded: "Skills loaded",
    subagentModelFlash: "flash",
    subagentModelPro: "pro",
    subagentModelHint: "Model used when this skill spawns its isolated subagent",
    sectionRuntime: "Runtime",
    activeModel: "active model",
    model: "Model",
    modelFlashDesc: "Flash — always flash",
    modelProDesc: "Pro — always pro",
    modelPricingLine: "${hit} hit · ${miss} miss · ${out} out  per 1M tok",
    editMode: "edit mode",
    editModeNote: "switch from the Chat tab header",
    editModeHint: "Configure edit mode",
    showSystemEvents: "system events",
    showSystemEventsHint: "Show quiet inline notices for context compaction, abort, rate-limit.",
    shown: "shown",
    hidden: "hidden",
    sectionLanguage: "Language",
    language: "language",
    languageHint: "Switch language",
    langEn: "English",
    langZhCn: "简体中文",
    appMode: "App mode",
    appearanceSection: "Appearance",
    behaviorSection: "Behavior",
    ruleAutoApprovalHint: "Configure auto-approval rules",
    ruleAutoApprovalSection: "Auto-approval Rules",
    theme: "Theme",
    themeDark: "Dark",
    themeHint: "Switch between light and dark themes",
    themeLight: "Light",
    themeStyle: "Theme style",
    themeStyleHint: "Choose theme style",
    themeStyleGraphite: "Graphite",
    themeStyleGraphiteDesc: "Cool dark neutrals — best for long sessions.",
    themeStyleSandstone: "Sandstone",
    themeStyleSandstoneDesc: "Warm light tones — easy on bright rooms.",
    themeStylePorcelain: "Porcelain",
    themeStylePorcelainDesc: "Clean light with extra contrast.",
    themeStyleMidnight: "Midnight",
    themeStyleMidnightDesc: "Deep dark with cooler highlights.",
    pageGeneralLabel: "General",
    pageGeneralDesc: "Theme, fonts, language and workspace.",
    pageModelsLabel: "Models",
    pageModelsDesc: "Default model and reasoning effort.",
    pageMcpLabel: "MCP servers",
    pageMcpDesc: "Connect external tool servers.",
    pageSkillsLabel: "Skills",
    pageSkillsDesc: "User-defined skills you can run with /skill.",
    pageMemoryLabel: "Memory",
    pageMemoryDesc: "Long-lived notes carried across sessions.",
    pageRulesLabel: "Rules",
    pageRulesDesc: "Auto-approval rules for shell + path access.",
    pageBillingLabel: "Billing",
    pageBillingDesc: "API key, balance and per-session budget.",
    pageShortcutsLabel: "Shortcuts",
    pageShortcutsDesc: "Keyboard shortcuts reference.",
    fontFamily: "Font family",
    fontFamilyHint: "Choose font family",
    fontFamilySans: "Sans-serif",
    fontFamilySerif: "Serif",
    fontFamilySystem: "System",
    fontScale: "Font scale",
    fontScaleHint: "Adjust font size",
    fontScaleLarge: "Large",
    fontScaleMedium: "Medium",
    fontScaleSmall: "Small",
    currentWorkspace: "Current workspace",
    defaultModelCurrent: "Current model",
    editor: "Editor",
    editorHint: "Configure editor preferences",
    maxOutput: "Max output",
    reasoningEffort: "Reasoning effort",
    reasoningEffortHint: "Adjust reasoning depth",
    sessionCost: "Session cost",
    balanceAvailable: "Available",
    balanceLabel: "Balance",
    balanceLow: "Low balance",
    cacheHitRate: "Cache hit rate",
    ctxWindow: "Context window",
    notSelected: "Not selected",
    parseError: "Parse error",
    workspaceChange: "Change",
    workspaceSection: "Workspace",
    mcpAdd: "Add",
    mcpAddSection: "Add MCP Server",
    mcpBridged: "Bridged",
    mcpConfigured: "Configured",
    mcpEmpty: "No MCP servers",
    mcpNotBridged: "Not bridged",
    mcpRemove: "Remove",
    mcpSpecFormat: "JSON format",
    mcpSpecLabel: "Server spec",
    memoryDesc: "Configure memory settings",
    memorySection: "Memory",
    shortcutAbort: "Abort",
    shortcutCloseTab: "Close Tab",
    shortcutCommandPalette: "Command Palette",
    shortcutFocusComposer: "Focus Composer",
    shortcutNewChat: "New Chat",
    shortcutNewTab: "New Tab",
    shortcutSettings: "Settings",
    shortcutSwitchTab: "Switch Tab",
    qqAccessAllowlist: "Allowlist",
    qqAccessOpen: "Open",
    qqAccessOwner: "Owner",
    qqAccessOwnerWithAllowlist: "Owner + Allowlist",
    qqAccessRuntime: "Runtime",
    qqAppId: "App ID",
    qqApplyAction: "Apply",
    qqApplyLabel: "Apply",
    qqAppSecret: "App Secret",
    qqBack: "Back",
    qqConfigure: "Configure",
    qqConfigureHint: "Set up QQ integration",
    qqConfigureTitle: "QQ Configuration",
    qqConnected: "Connected",
    qqConnecting: "Connecting…",
    qqDisconnected: "Disconnected",
    qqEnvironment: "Environment",
    qqFailed: "Failed",
    qqProduction: "Production",
    qqSandbox: "Sandbox",
    qqSave: "Save",
    qqSaveAndConnect: "Save & Connect",
    qqSection: "QQ Integration",
    qqSummaryAppId: "App ID",
    qqSummaryDetail: "Details",
    qqSummaryMissing: "Not configured",
    qqTitle: "QQ Bot",
  },
  chat: {
    modeMirror: "TUI mirror",
    modeView: "session view",
    placeholder: "Type a prompt — Enter sends, Shift+Enter for a newline · / @ for pickers",
    placeholderBusy: "wait for the current turn to finish…",
    placeholderSteerBusy: "type to steer — commands and pickers are disabled while busy",
    steerHint: "message steers the current turn (added as instruction)",
    send: "Send",
    new: "New",
    clear: "Clear",
    newTitle: "/new — wipe conversation context (loop log + scrollback)",
    clearTitle: "/clear — wipe just visible scrollback (context kept)",
    noConversation: "No conversation yet. Send a prompt below to begin.",
    newConfirmBusy: "A turn is in flight. Abort and start a new conversation?",
    newConfirm: "Clear current conversation and start fresh?",
    newToast: "new conversation",
    clearToast: "scrollback cleared",
    newFailed: "/new failed: {error}",
    clearFailed: "/clear failed: {error}",
    eventStreamError: "event stream interrupted — reconnecting…",
    semanticBanner: "Semantic search isn't enabled for this project.",
    semanticBannerDesc:
      'Build the index once and the model can find code by meaning ("where do we handle auth failures?") instead of grep on exact strings.',
    semanticBannerBtn: "Build it →",
    semanticBannerDismiss: "dismiss (don't show again)",
    slashCommands: "slash commands",
    projectFiles: "project files",
    effortTitle: "reasoning_effort — applies next turn",
    effortMaxTitle: "max (DeepSeek extension)",
    effortHighTitle: "high (safe default — vLLM / Azure compatible)",
    effortMediumTitle: "medium",
    effortLowTitle: "low (fastest)",
    editGateTitle: "edit gate — Shift+Tab cycles in TUI",
    editReviewTitle: "review — both edits and non-allowlisted shell ask first",
    editAutoTitle: "auto — edits auto-apply, shell still asks",
    editYoloTitle: "yolo — edits AND shell auto-run, allowlist bypassed",
    railSession: "Session",
    railTurns: "turns",
    railPromptTok: "prompt tok",
    railCost: "cost",
    railCacheHit: "cache hit",
    railToolBudget: "Tool budget",
    railSpend: "spend",
    railActivePlan: "Active plan",
    railProgress: "progress",
    statusModel: "model",
    statusCtx: "ctx",
    statusCache: "cache",
    statusTurn: "turn",
    statusSession: "session",
    statusBalance: "balance",
    statusTurns: "{count} turn{s}",
    waitingStats: "· · ·  waiting for live stats",
    inflightPhase: "{phase}",
    inflightRunning: "running",
    inflightThinking: "thinking",
    inflightStreaming: "streaming",
    inflightWaiting: "waiting",
    inflightReasoning: "reasoning {count} ch",
    inflightOut: "out {count} ch",
    abortBtn: "Abort (Esc)",
    confirmBtn: "Apply (y)",
    rejectBtn: "Reject (n)",
    applyRestBtn: "Apply rest (a)",
    flipAutoBtn: "Flip to AUTO (A)",
  },
  overview: {
    loading: "loading overview…",
    failed: "overview failed: {error}",
    standaloneTitle: "Standalone mode",
    standaloneDesc:
      "Read-only disk view. Start /dashboard from inside reasonix code for live session state, MCP, and tools.",
    cockpit: "Cockpit",
    balance: "balance",
    tokens7d: "tokens · 7d",
    cacheHit: "cache hit",
    toolCalls24h: "tool calls · 24h",
    budget: "budget",
    currentSession: "current session",
    noSession: "No live session — /dashboard from inside reasonix code to attach.",
    promptTok: "prompt tok",
    completionTok: "completion tok",
    cost: "cost",
    costTrend: "cost · 14 day",
    noUsageYet: "no usage yet",
    dayAvg: "/day avg",
    recentPlans: "recent plans",
    noPlans: "No plans yet — submit one with submit_plan.",
    toolActivity: "tool activity",
    noToolCalls: "No tool calls yet.",
    toolsLoaded: "tools loaded",
    mcpServers: "mcp servers",
    editMode: "edit mode",
    version: "Reasonix",
    workingDir: "Working directory",
    projectRoot: "project root",
    noPriorData: "no prior data",
    stable: "— stable",
    vsPrior: "{arrow} {pct}% vs prior",
    active: "active",
    allUp: "all up",
    yoloWarning: "all prompts bypassed",
    checking: "checking",
    latest: "latest",
  },
  usage: {
    loading: "loading usage…",
    failed: "usage failed: {error}",
    records: "{count} records",
    dailyUsage: "Daily usage",
    dailyMeta: "cost · cache saved · turns",
    noData: "No usage data yet — run a turn in reasonix chat / code / run and refresh.",
    windows: "Rolling windows",
    colWindow: "window",
    colTurns: "turns",
    colCacheHit: "cache hit",
    colCost: "cost (USD)",
    colCacheSaved: "cache saved",
    colVsClaude: "vs Claude",
    colSaved: "saved",
    axisTime: "time",
    axisUsd: "USD",
    axisTurns: "turns",
    seriesCost: "cost",
    seriesCacheSaved: "cache saved",
    seriesTurns: "turns",
    mostUsed: "Most used models",
    colModel: "model",
  },
  sessions: {
    loading: "loading sessions…",
    failed: "sessions failed: {error}",
    noSessions: "No saved sessions yet.",
    filterPlaceholder: "filter sessions",
    msgs: "msgs",
    pickHint: "Pick a session on the left to read its transcript.",
    resumeTitle: "Resume in TUI",
    resumeDesc:
      "Mid-session swap requires a restart so the message log can rewind cleanly. Quit your current session, then run:",
    loadingTranscript: "loading transcript…",
    emptyTranscript: "empty transcript.",
    messages: "{count} message{s}",
    newBtn: "New session",
    newHint: "Archive the current conversation and start a fresh one",
    switchBtn: "Switch to this session",
    deleteBtn: "Delete",
    deleteConfirm: "Delete session \"{name}\"? This removes the transcript file and cannot be undone.",
    cantDeleteActive: "Switch to a different session before deleting this one.",
    attachRequired:
      "Live session operations need an attached CLI session. Launch via reasonix chat or open the dashboard from inside a TUI session.",
    activeChip: "active",
    activePill: "active",
  },
  tools: {
    loading: "loading tools…",
    failed: "tools failed: {error}",
    noTools: "No tools registered.",
    planMode: "plan mode — writes gated",
    colTool: "tool",
    colFlags: "flags",
    colDesc: "description",
    readOnly: "read-only",
    write: "write",
    flat: "flat",
    desc: {
      web_search:
        "Search the public web. Returns ranked results with title, url, and snippet. Call this when the answer depends on current state — events, prices, releases, real-world status.",
      web_fetch:
        "Download a URL and return its visible text content (scripts/styles/nav stripped). Use after web_search when a snippet isn't enough.",
      run_command:
        "Run a shell command in the project root; returns combined stdout+stderr. Allowlisted read-only commands run immediately; mutations are gated by user confirmation.",
      run_background:
        "Spawn a long-running process and detach. Returns a job id for tailing logs, waiting for completion, or killing. Use for dev servers, watchers, and one-shot long jobs.",
      job_output:
        "Read the latest output of a background job. Returns the tail of the buffer and tells you whether the job is still running.",
      wait_for_job:
        "Block server-side until a background job finishes, bounded by timeout. Use instead of polling job_output in a loop.",
      stop_job:
        "Stop a background job. SIGTERM first, SIGKILL after a grace period. Safe to call on an already-exited job.",
      list_jobs:
        "List every background job started this session — running and exited — with id, command, pid, and status.",
      remember:
        "Save a memory for future sessions. Use when the user states a preference, corrects your approach, shares a non-obvious fact, or asks you to remember something.",
      forget:
        "Delete a memory file and remove it from MEMORY.md. Use when the user asks to forget something or a remembered fact is now wrong.",
      recall_memory:
        "Read the full body of a memory file when its one-line summary isn't enough detail.",
      read_file:
        "Read a file under the sandbox root. Supports head/tail/range scoping to save context. Auto-returns a preview for files over 200 lines.",
      list_directory:
        "List entries in a directory. Returns one line per entry, marking directories with a trailing slash.",
      directory_tree:
        "Recursively list entries in a directory as an indented tree. Budget-aware with auto-collapse for large subtrees.",
      search_files:
        "Find files whose NAME matches a substring or regex. Case-insensitive. Skips dependency/build directories by default.",
      search_content:
        "Recursively grep file CONTENTS for a substring or regex. Returns matches in path:line:text format. The right tool for finding references.",
      glob: "List files matching a glob pattern, sorted by mtime. Default limit 200, max 1000. Skips node_modules/.git/dist by default.",
      get_file_info: "Stat a path under the sandbox root. Returns type, size in bytes, and mtime.",
      write_file:
        "Create or overwrite a file with the given content. Parent directories are created as needed.",
      edit_file:
        "Apply a SEARCH/REPLACE edit to an existing file. The search must match exactly and be unique in the file.",
      multi_edit:
        "Apply N SEARCH/REPLACE edits across one or more files atomically. If any edit fails, no files are written.",
      create_directory: "Create a directory (and any missing parents) under the sandbox root.",
      move_file: "Rename or move a file or directory under the sandbox root.",
      delete_file:
        "Delete one file under the sandbox root. Refuses directories — use delete_directory for those.",
      delete_directory:
        "Recursively delete a directory under the sandbox root. Pass recursive:false to refuse non-empty directories.",
      copy_file:
        "Copy a file or directory under the sandbox root. Refuses to overwrite an existing destination.",
      submit_plan:
        "Submit one concrete plan for a review gate. Use for multi-file refactors, architecture changes, or anything expensive to undo.",
      mark_step_complete:
        "Mark one step of the approved plan as done. Call exactly once after finishing each step.",
      revise_plan:
        "Surgically replace the remaining steps of an in-flight plan. Done steps are never touched.",
      run_skill:
        "Invoke a playbook from the Skills index. Pass the bare skill name. Subagent-tagged skills spawn an isolated subagent.",
      spawn_subagent:
        "Spawn an isolated subagent for a self-contained subtask. Use for parallel fan-out or when the work needs many file reads.",
      todo_write:
        "In-session task tracker for multi-step work. Replaces the entire list every call. No approval gate or file writes.",
      ask_choice:
        "Present 2-6 alternatives to the user. Use when the user asks for options or you need a preference decision.",
      create_skill:
        "Scaffold a new skill the user can invoke later via /skill. Supports inline and subagent run modes.",
      add_mcp_server:
        "Register a new MCP server in the user's config. Takes effect on the next session. Supports stdio, SSE, and streamable-http.",
    },
  },
  permissions: {
    loading: "loading permissions…",
    failed: "permissions failed: {error}",
    yoloTitle: "YOLO mode",
    yoloDesc:
      "Every shell command auto-runs, allowlist bypassed. Switch back with /mode review in the TUI.",
    project: "project",
    builtin: "builtin",
    addPrefix: "add a prefix",
    addPlaceholder: 'e.g. "npm run build" or "deploy.sh"',
    clearAll: "Clear all",
    alreadyIn: "{prefix} already in list",
    added: "added: {prefix}",
    removed: "removed: {prefix}",
    cleared: "cleared {count} entr{y}",
    removeConfirm: 'Remove "{prefix}" from this project\'s allowlist?',
    clearConfirm: "Wipe every project allowlist entry? Builtin entries are unaffected.",
    projectAllowlist: "Project allowlist · {count}",
    nothingStored: "Nothing stored yet for this project.",
    colNum: "#",
    colPrefix: "prefix",
    builtinTitle: "Builtin · {count} · read-only",
    standaloneWarning:
      "Mutations require /dashboard from inside an active reasonix code session — standalone reasonix dashboard can't tell which project's allowlist to edit.",
  },
  mcp: {
    loading: "loading MCP…",
    servers: "MCP servers · {count} bridged",
    all: "all",
    live: "live",
    unbridged: "unbridged",
    specPlaceholder: "spec — e.g. fs=npx -y @modelcontextprotocol/...",
    saved: "saved",
    savedRestart: "saved — restart reasonix code to bridge this server",
    removed: "removed — restart to drop the live bridge",
    removeConfirm: "Remove MCP spec from config?\n\n{spec}",
    noServers: "No MCP servers in this session.",
    tools: "tools",
    inConfig: "in config · not loaded",
    unbridgedTitle: "unbridged · in config",
    removeBtn: "Remove",
    spec: "spec",
    whyUnbridged: "Why unbridged?",
    whyUnbridgedDesc:
      "This spec lives in your config.json but isn't bridged into the live session. MCP servers attach when reasonix code starts; the dashboard alone can't spawn the child process.",
    whyUnbridgedHint: "To activate: restart reasonix code, then refresh this dashboard.",
    bridgeFailed: "Bridge failed",
    bridgeFailedTitle: "bridge failed · in config",
    bridgeFailedHint:
      "Reasonix tried to bridge this server and the attempt errored. Common causes: wrong URL, missing auth header, upstream 404/5xx, missing local command. Fix and restart reasonix code to retry.",
    pickHint: "Pick an MCP server on the left to inspect tools / resources / prompts.",
    toolsTitle: "Tools · {count}",
    resourcesTitle: "Resources · {count}",
    promptsTitle: "Prompts · {count}",
    colName: "name",
    colDesc: "description",
    colUri: "uri",
    marketplace: "marketplace",
    marketplaceSearch: "search the registry…",
    marketplaceLoading: "loading registry…",
    marketplaceMore: "load 5 more pages",
    marketplaceMoreLabel: "load 50 more  ·  showing {shown} / {total}",
    marketplaceMoreHint: "fetches more pages from the registry",
    marketplaceMoreCachedHint: "more entries already cached locally",
    marketplaceExhausted: "all pages loaded",
    marketplaceExhaustedFull: "showing all {total} entries — registry exhausted",
    marketplaceCount: "{loaded} loaded · {matched} match · source: {source}{cached}",
    marketplaceCachedSuffix: " · cached",
    marketplaceNoMatches: "No matches. Try different terms or load more pages.",
    marketplaceInstall: "Install",
    marketplacePickHint: "Pick a server on the left, then Install.",
    marketplaceInstalled: "installed → {spec}",
    marketplaceInstalledBridged: "installed + bridged → {spec}",
    marketplaceAlready: "already installed",
    marketplaceNeedsEnv: "needs env: {names}",
    marketplaceSourceTag: "[{source}]",
    marketplaceNoInstall:
      "smithery listing — install metadata not exposed; use `npx -y @smithery/cli install {name}` directly",
    marketplaceFetchOnInstall:
      "Smithery listing — install detail fetched on Install. http servers map to streamable-http remotes; stdio servers run via @smithery/cli.",
    marketplaceInstalledBadge: "installed",
    marketplaceUninstall: "Uninstall",
    marketplaceEnvTitle: "Required environment variables",
    marketplaceEnvHint:
      "Set these in your shell before next `reasonix code` so the bridged server can authenticate.",
    marketplaceRestartHint:
      "Spec written to ~/.reasonix/config.json. Restart `reasonix code` to bridge the server (live hot-reload is on the roadmap).",
  },
  memory: {
    loading: "loading memory…",
    files: "memory · {count} files",
    exists: "exists",
    create: "create",
    noFiles: "No memory files yet.",
    pickHint: "Pick a memory file on the left.",
    pickDesc: "Project REASONIX.md is committable; global notes live in ~/.reasonix/memory/.",
    chars: "{count} chars",
    saved: "saved {scope}",
    reloadHint: "re-applied on next /new or session restart",
  },
  hooks: {
    loading: "loading hooks…",
    resolved: "resolved",
    eventMatrix: "Event matrix",
    matrixSub: "{scripts} script{s} × {events} event{s}",
    noHooks: "No hooks configured. Edit the JSON below to add some.",
    colScript: "script",
    noProject: "No active project — open /dashboard from reasonix code to edit project hooks.",
    saveReload: "Save + Reload",
    discard: "Discard changes",
    savedReloaded: "saved + reloaded {scope}",
    recentRuns: "Recent runs",
    noRuns: "No hook runs in the recent session log.",
    colWhen: "when",
    colPhase: "phase",
    colHook: "hook",
    colOutcome: "outcome",
  },
  skills: {
    loading: "loading skills…",
    filterPlaceholder: "filter skills",
    project: "project",
    custom: "custom",
    global: "global",
    builtin: "builtin",
    newSkill: "new skill",
    noDescription: "(no description)",
    runs7d: "runs · 7d",
    pickHint: "Pick a skill on the left, or create a new one above.",
    readOnlyBuiltin: "read-only · builtin",
    readOnlyCustom: "read-only · custom path",
    builtinDesc:
      "Built-in skills ship with Reasonix; the model picks them up automatically. To customize, create a project- or global-scoped skill with the same name.",
    saved: "saved {scope}/{name}",
    deleteConfirm: "Delete skill {scope}/{name}?",
    reloadHint: "re-loaded on next /new or session restart",
  },
  system: {
    loading: "loading health…",
    failed: "health failed: {error}",
    healthChecks: "Health checks",
    version: "version",
    checking: "checking",
    latest: "● latest",
    outOfDate: "● out of date",
    versionPending: "version check pending",
    upToDate: "up to date",
    latestVer: "latest: {version}",
    sessions: "sessions",
    ok: "● ok",
    memory: "memory",
    semanticIndex: "semantic index",
    built: "● built",
    none: "— none",
    runIndex: "run reasonix index to build",
    usageLog: "usage log",
    backgroundJobs: "background jobs",
    noSession: "— no session",
    running: "{count} running",
    attachHint: "attach a session to see jobs",
    shellSpawn: "shell + spawn",
    paths: "paths",
    home: "home",
    sessionsPath: "sessions",
    memoryPath: "memory",
    semanticPath: "semantic",
    usagePath: "usage",
  },
  plans: {
    loading: "loading plans…",
    failed: "plans failed: {error}",
    noPlans: "No archived plans yet — run a turn that calls submit_plan and mark_step_complete.",
    filterPlaceholder: "filter plans",
    active: "active",
    done: "done",
    idle: "idle",
    steps: "steps",
    pickHint: "Pick a plan on the left.",
    noTitle: "(no title)",
    stepTimeline: "Step timeline · {done} / {total}",
    step: "step {n}",
  },
  semantic: {
    codeRequired: "Semantic — code-mode required",
    indexBuilt: "index built",
    noIndex: "no index yet",
    ready: "ready",
    setupNeeded: "setup needed",
    installOllama: "Install Ollama",
    installOllamaDesc:
      "Reasonix doesn't run package managers for you. Install Ollama first, then come back:",
    macWindows: "macOS / Windows:",
    download: "download from ollama.com/download",
    linux: "Linux:",
    refreshHint:
      "Refresh after install — this panel will offer to start the daemon and pull {model}.",
    daemon: "Daemon",
    daemonDesc: "ollama is on your PATH but the HTTP daemon isn't reachable.",
    startDaemon: "Start daemon",
    runsOllama: "runs ollama serve detached",
    model: "Model",
    modelMissing: "{model} isn't installed yet.",
    modelSize: "~270 MB on first pull.",
    pulling: "pulling…",
    pullModel: "Pull {model}",
    indexStatus: "index status",
    builtStatus: "● built",
    incompatibleStatus: "● incompatible",
    chunks: "chunks",
    files: "files",
    dim: "dim",
    size: "size",
    lastBuild: "last build",
    builtWith: "built with",
    currentTarget: "current target",
    incompatibleHint:
      "This on-disk index was built for a different provider or model. Run Rebuild to replace it.",
    runIndexHint: "Run an index to enable semantic_search.",
    reIndex: "Re-index",
    build: "Build",
    rebuild: "Rebuild",
    stop: "Stop",
    provider: "provider",
    providerType: "service type",
    openaiCompat: "openai-compatible",
    apiUrl: "API URL",
    apiKey: "API key",
    apiKeyStoredNote: "API key is stored in ~/.reasonix/config.json — do not share that file.",
    customRequestBody: "custom request body",
    invalidCustomRequestBody: "Custom request body must be valid JSON: {error}",
    customRequestBodyMustBeObject: "Custom request body must be a JSON object.",
    saveBeforeIndex: "Save semantic settings before starting an index.",
    extraBody: "extra body",
    batchSize: "batch size",
    keepExistingKey: "leave blank to keep existing key",
    remoteProvider: "Remote embedding provider",
    remoteProviderDesc:
      "Configure the full OpenAI-compatible embeddings URL here. Reasonix will send requests exactly to the URL you provide.",
    ollama: "ollama",
    binary: "binary",
    found: "found",
    missing: "missing",
    daemonStatus: "daemon",
    up: "up",
    down: "down",
    pulled: "pulled",
    indexConfig: "index config",
    reset: "reset",
    excludeDirs: "exclude dirs",
    excludeFiles: "exclude files",
    excludeExts: "exclude exts",
    excludePatterns: "exclude patterns",
    glob: "glob",
    respectGitignore: "respect .gitignore",
    maxFileBytes: "max file bytes",
    skipLarger: "skip files larger than ~{size} MiB",
    preview: "Preview",
    searchPlaceholder: "describe what to find — 'where do we handle abort signals'",
    searching: "searching…",
    results: "{count} result{s} · {ms}ms · {model}",
    noMatches: "No matches above the score threshold.",
    previewSummary: "Preview — would index {included} file(s), skip {skipped}",
    nothingSkipped: "nothing skipped — all walked files would be indexed.",
    firstIncluded: "first {count} included file(s)",
    job: "Job",
    phaseSetup: "preparing",
    phaseScan: "scanning files",
    phaseEmbed: "embedding chunks",
    phaseWrite: "writing index",
    phaseDone: "done",
    phaseError: "error",
    phaseCancelled: "cancelled",
    setupFailed: "setup failed",
    stopping: "stopping",
    scanned: "scanned {count}",
    changed: "changed {count}",
    skipped: "skipped {count}",
    chunksProgress: "{done} / {total} ({pct}%)",
    result: "result",
    added: "added {count}",
    removed: "removed {count}",
    failed: "failed {count}",
    skippedFiles: "{total} files ({details})",
    rebuildStarted: "rebuild started",
    incrementalStarted: "incremental index started",
    stopRequested: "stopping requested — current chunk batch will finish first",
    startingDaemon: "starting ollama daemon (15s timeout)…",
    daemonUp: "daemon is up",
    daemonTimeout: "daemon didn't come up in time — check ollama serve manually",
    pullingModel: "pulling {model} — this may take a few minutes on first install",
    savedConfig: "saved · {count} fields updated · re-run index to apply",
    runningPreview: "running dry walk against project root…",
    exclude: "exclude",
  },
  modal: {
    shellTitle: "shell command",
    shellBgTitle: "background process",
    shellSubtitle: "model wants to run a shell command",
    shellBgSubtitle: "long-running — keeps running after approval",
    pathTitle: "file outside sandbox",
    pathSubtitle: "{intent} via {tool}",
    pathRead: "read",
    pathWrite: "write",
    pathSandboxLabel: "sandbox",
    pathAllowPrefixLabel: "allow prefix",
    runOnce: "Run once",
    alwaysAllow: 'Always allow "{prefix}"',
    deny: "Deny",
    choiceTitle: "model wants you to pick",
    typeOwn: "Type my own answer",
    typeOwnSummary: "None of the above fits — write a free-form reply.",
    typePlaceholder: "Type a free-form answer…",
    send: "Send",
    cancel: "Cancel",
    cancelSummary: "Drop the question. Model will ask what you actually want.",
    planTitle: "plan submitted",
    planSubtitle: "model proposed a plan; review then pick",
    approveInstructions:
      "Optional last instructions / answers to open questions (Enter to send blank)",
    refinePlaceholder: "What needs to change? Be specific.",
    approve: "Approve",
    refine: "Refine",
    sendRefinement: "Send refinement",
    editTitle: "edit pending review",
    editSubtitle: "{path} · {remaining} of {total} blocks remaining",
    before: "before",
    after: "after",
    workspaceTitle: "model wants to switch workspace",
    workspaceSubtitle: "every subsequent file / shell / memory tool resolves against the new root",
    switchBtn: "Switch (Enter)",
    denyBtn: "Deny (Esc)",
    stepComplete: "step complete{counter}",
    continueBtn: "Continue",
    reviseBtn: "Revise…",
    stopBtn: "Stop",
    revisionTitle: "model proposed a plan revision",
    sendRevision: "Send revision",
    accept: "Accept",
    reject: "Reject",
    arguments: "arguments",
    revisePlaceholder: "What needs to change before the next step? Leave blank to just continue.",
    pickerFilter: "Filter…",
    pickerEmpty: "Nothing to show.",
    pickerLoadMore: "Load more",
    pickerPick: "Open",
    pickerInstall: "Install",
    pickerUninstall: "Uninstall",
    pickerRename: "Rename…",
    pickerNew: "New…",
    pickerNewPlaceholder: "Name (leave blank for default)",
    viewerClose: "Close",
  },
  error: {
    title: "Something broke in the dashboard",
    body: "The TUI is unaffected — only this browser tab tripped. You can dismiss and keep working, or report it so we can fix the underlying cause.",
    copyDetails: "Copy details",
    copied: "Copied ✓",
    reportOnGithub: "Report on GitHub",
    dismiss: "Dismiss (Esc)",
    crashing: "this panel keeps crashing — {name}",
    retry: "Try again",
    recovering: "recovering…",
  },
  fmt: {
    justNow: "just now",
    minutesAgo: "{n}m ago",
    hoursAgo: "{n}h ago",
    daysAgo: "{n}d ago",
  },
  cards: {
    applied: "Applied",
    cacheHit: "Cache hit",
    checkpointRewind: "Checkpoint Rewind",
    cost: "Cost",
    diffApply: "Apply",
    diffApplyChanges: "Apply Changes",
    diffAwaiting: "Awaiting review",
    diffDiscard: "Discard",
    done: "Done",
    elapsed: "Elapsed",
    error: "Error",
    errorName: "Error",
    failed: "Failed",
    hits: "Hits",
    memoryCountSuffix: "memories",
    memoryName: "Memory",
    output: "Output",
    planDefaultTitle: "Plan",
    prompt: "Prompt",
    compactionMeta: "{chars} chars",
    compactionName: "Compacted history",
    reasoningComplete: "Reasoning complete",
    reasoningName: "Reasoning",
    result: "Result",
    running: "Running",
    searchName: "Search",
    shellAlwaysAllow: "Always Allow",
    shellAwaiting: "Awaiting approval",
    shellExecuteHint: "Execute this command?",
    shellReject: "Reject",
    shellRun: "Run",
    shellRunning: "Running",
    streaming: "Streaming",
    subagentDone: "Subagent done",
    subagentDoneProgress: "Subagent done ({pct}%)",
    subagentFailed: "Subagent failed",
    subagentRunning: "Subagent running",
  },
  planBadge: {
    blocked: "Blocked",
    done: "Done",
    failed: "Failed",
    pending: "Pending",
    running: "Running",
  },
  composer: {
    atHeader: "Mention files",
    close: "Close",
    commandPalette: "Command Palette",
    commands: "Commands",
    commandsLabel: "Commands",
    confirm: "Confirm",
    imageFilterName: "Images",
    insertFile: "Insert File",
    insertImage: "Insert Image",
    interrupt: "Interrupt",
    mentionFiles: "Mention Files",
    mentionLabel: "Mention",
    newline: "New Line",
    noMatches: "No matches",
    placeholder: "Type a prompt…",
    queue: "Queue",
    queueCount: "{count} queued",
    select: "Select",
    send: "Send",
    slashHeader: "Slash Commands",
    switchModel: "Switch Model",
    switchEffort: "Switch Reasoning Effort",
    workspaceRoot: "Workspace Root",
  },
  contextPanel: {
    allow: "Allow",
    ask: "Ask",
    autoApproveTitle: "Auto-approve",
    cacheKey: "Cache",
    contextTokens: "Context tokens",
    fileInContext: "In context",
    fileModified: "Modified",
    filesCount: "{count} files",
    filesTab: "Files",
    filesTitle: "Files",
    freeKey: "Free",
    itemCount: "{count} items",
    mcpConfigured: "Configured",
    mcpConnecting: "Connecting…",
    mcpDisabled: "Disabled",
    mcpEmpty: "No MCP servers",
    mcpFailed: "Failed",
    mcpReady: "Ready",
    mcpReadyAll: "All ready",
    mcpReadySome: "Some ready",
    mcpTitle: "MCP",
    mcpTools: "Tools",
    memoryTab: "Memory",
    memoryTitle: "Memory",
    noFilesMsg: "No files in context",
    noMemoriesMsg: "No memories",
    reservedKey: "Reserved",
    ruleReadOnly: "Read-only",
    ruleReview: "Review",
    ruleShellAllowlist: "Shell allowlist",
    rulesTab: "Rules",
    ruleWritesAsk: "Writes ask",
    ruleYolo: "YOLO",
    scopeGlobal: "Global",
    scopeProject: "Project",
    toolsTab: "Tools",
    usedKey: "Used",
  },
  dragDrop: {
    overlay: "Drop files here",
  },
  extraCards: {
    approve: "Approve",
    balance: "Balance",
    cache: "Cache",
    cacheHit: "Cache hit",
    contextWindow: "Context window",
    doctorTitle: "Diagnostics",
    output: "Output",
    prompt: "Prompt",
    reasoning: "Reasoning",
    reject: "Reject",
    sessionCost: "Session cost",
    sessionUsage: "Session usage",
    topToolsUsage: "Top tools",
    unknownKind: "Unknown",
    memoryUser: "User",
    memoryFeedback: "Feedback",
    memoryProject: "Project",
    memoryReference: "Reference",
  },
  jobs: {
    empty: "No background jobs",
    exited: "Exited",
    kbClose: "Close",
    kbToggle: "Toggle",
    running: "Running",
    stop: "Stop",
    stopAll: "Stop All",
    stopAllTip: "Stop all jobs",
    stopOne: "Stop",
    title: "Background Jobs",
  },
  live: {
    deliveredWaiting: "Waiting for next message",
    reasoning: "Reasoning",
    running: "Running",
    secondsAgo: "{n}s ago",
    you: "You",
  },
  markdown: {
    copied: "Copied!",
    copy: "Copy",
    externalLinkTitle: "Open in new tab",
    filePillTitle: "Open file",
    localLinkTitle: "Open link",
  },
  palette: {
    abort: "Abort",
    abortHint: "Abort current request",
    about: "About",
    clearChat: "Clear Chat",
    clearChatHint: "Clear conversation",
    closeTab: "Close Tab",
    closeTabHint: "Close current tab",
    copyConv: "Copy Conversation",
    copyConvHint: "Copy conversation as Markdown",
    copyLast: "Copy Last Response",
    copyLastHint: "Copy last assistant message",
    countSuffix: "items",
    empty: "No matching commands",
    exportMd: "Export as Markdown",
    exportMdHint: "Export chat as Markdown file",
    focusComposer: "Focus Composer",
    footClose: "Close",
    footMove: "Move",
    footRun: "Run",
    groupAction: "Actions",
    groupNav: "Navigation",
    groupSettings: "Settings",
    groupWorkspace: "Workspace",
    newChat: "New Chat",
    newChatHint: "Start a new conversation",
    newTab: "New Tab",
    newTabHint: "Open a new tab",
    pickWorkspace: "Switch Workspace",
    pickWorkspaceHint: "Change workspace",
    searchPlaceholder: "Search commands…",
    settings: "Settings",
    settingsHint: "Open settings",
  },
  panel: {
    renderError: "Panel crashed",
  },
  sidebarPanel: {
    approvalRules: "Approval Rules",
    cancel: "Cancel",
    commandPalette: "Command Palette",
    daysAgo: "{n}d ago",
    delete: "Delete",
    deleteSession: "Delete Session",
    hoursAgo: "{n}h ago",
    justNow: "Just now",
    loading: "Loading…",
    messageCount: "{count} messages",
    minutesAgo: "{n}m ago",
    newChat: "New Chat",
    noMatches: "No matches",
    noSessions: "No sessions",
    recent: "Recent",
    searchSessions: "Search sessions…",
    sessionTitle: "Sessions",
    settings: "Settings",
    weeksAgo: "{n}w ago",
  },
  statusbar: {
    balance: "Balance",
    busy: "Busy",
    cache: "Cache",
    cacheHit: "Cache hit",
    jobs: "Jobs",
    jobsTip: "Background jobs",
    offline: "Offline",
    online: "Online",
    switchCurrency: "Switch currency",
    switchTheme: "Switch theme",
    switchWorkspace: "Switch workspace",
    themeDark: "Dark",
    themeLight: "Light",
    themeStyleGraphite: "Graphite",
    themeStyleSandstone: "Sandstone",
    themeStylePorcelain: "Porcelain",
    themeStyleMidnight: "Midnight",
    thisTurn: "This turn",
    tokens: "Tokens",
  },
  thread: {
    activePlan: "Active plan",
    allowRead: "Allow read",
    allowWrite: "Allow write",
    alwaysAllow: "Always allow",
    alwaysAllowPrefix: "Always allow {prefix}",
    approve: "Approve",
    approveRewrite: "Approve rewrite",
    cancel: "Cancel",
    checkpointKind: "Checkpoint",
    checkpointSub: "Save current state",
    checkpointTitle: "Create checkpoint",
    collapse: "Collapse",
    continue: "Continue",
    copyMessage: "Copy message",
    copyResponse: "Copy response",
    execute: "Execute",
    keepOriginal: "Keep original",
    keepSteps: "Keep steps",
    optionCount: "{count} options",
    pathAccessKind: "Path access",
    planConfirmationKind: "Plan approval",
    planRevisionKind: "Plan revision",
    planRunning: "Plan in progress",
    planStepCount: "Step {done}/{total}",
    readPathOutsideSandbox: "Read path outside sandbox",
    refine: "Refine",
    reject: "Reject",
    revise: "Revise",
    revisionMeta: "Revision",
    rewritePlan: "Rewrite plan",
    risk: "Risk assessment",
    riskMedium: "Medium risk",
    runBackgroundCommand: "Run in background",
    runCommand: "Run command",
    shellConfirmationKind: "Shell confirmation",
    startPlan: "Start plan",
    stop: "Stop",
    subagent: "Subagent",
    userChoiceKind: "User choice",
    writePathOutsideSandbox: "Write path outside sandbox",
    you: "You",
  },
  workdir: {
    browse: "Browse…",
    cancel: "Cancel",
    empty: "No workspaces",
    emptyDir: "No subdirectories.",
    go: "Go",
    goTip: "Navigate to this path",
    loading: "Loading…",
    openHere: "Open this folder",
    pathPlaceholder: "Absolute path…",
    promptWeb: "Enter the absolute path of the workspace to open:",
    searchPlaceholder: "Search workspaces…",
    title: "Workspace",
  },
  about: {
    close: "Close",
    repo: "Repository",
    sidebarLabel: "About",
    tagline: "AI-powered coding assistant",
    version: "Version",
  },
  effort: {
    lowDesc: "fastest — minimal reasoning",
    mediumDesc: "balanced",
    highDesc: "default — safe for vLLM / Azure",
    maxDesc: "DeepSeek extension; rejected by stock OpenAI / vLLM",
  },
  editMode: {
    plan: "Plan",
    planHint: "read-only · all write tools refuse to dispatch",
    review: "Review",
    reviewHint: "both edits and non-allowlisted shell ask first",
    auto: "Auto",
    autoHint: "edits auto-apply, shell still asks",
    yolo: "YOLO",
    yoloHint: "edits AND shell auto-run, allowlist bypassed",
  },
};
